// reset-password.component.ts
import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Login } from 'src/app/shared/model/login.model';
import { LoginService } from 'src/app/shared/services/login-service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent {
     login:Login = new Login();
     showPassword: boolean = false;
showConfirmPassword: boolean = false;
     
  resetPasswordData = {
    email: '',
    password: '',
    confirmPassword: ''
  };
     constructor(
      private userLogInServices:LoginService,
       private toastr: ToastrService,
        ){}
  onSubmit() {
    debugger
    if (this.resetPasswordData.password !== this.resetPasswordData.confirmPassword) {
      this.toastr.error('confirm password do not match.');
      return;
    }
    const data = { email: this.resetPasswordData.email, password: this.resetPasswordData.password, confirmPassword: this.resetPasswordData.confirmPassword};
    // Call your API here
    this.userLogInServices.resetEmpPassword(data).subscribe(
      
      (res: any) => {
        if (res) {
          this.toastr.success("The password is reset successfully.");
        } else {
          this.toastr.error("An error occurred. Please try again.");
        }
      },
      (err: any) => {
        console.error("API Error: ", err);
        this.toastr.error("Failed to send the reset link. Please check your network and try again.");
      }
    );
  }
  togglePasswordVisibility(field: string) {
    if (field === 'password') {
      this.showPassword = !this.showPassword;
    } else if (field === 'confirmPassword') {
      this.showConfirmPassword = !this.showConfirmPassword;
    }
  }
}